import {
  getNotFromSimpleFilter,
  getOperatorFromQueryFilter,
  getOperatorFromSimpleFilter,
} from '@/sections/insights/queryBuilder/entities/common/translators';
import type {
  SimpleFilter,
  SimpleFilterDefinition,
} from '@/sections/insights/queryBuilder/entities/types';
import type { QueryFilter } from '@/types';

/**
 * AWS Resource Type filter definition
 * Free-text input for values like AWS::S3::Bucket, AWS::EC2::Instance
 */
export const AWSResourceType: SimpleFilterDefinition = {
  apiField: 'resourceType',
  uiField: 'Resource Type',
  inputType: 'text',
  operators: ['is', 'is not', 'contains', 'starts with', 'ends with'],

  translateForUI: (queryFilter: QueryFilter): SimpleFilter => ({
    field: 'Resource Type',
    operator: getOperatorFromQueryFilter(queryFilter),
    value: queryFilter.value as string | string[],
  }),

  translateForAPI: (simpleFilter: SimpleFilter): QueryFilter => ({
    field: 'resourceType',
    operator: getOperatorFromSimpleFilter(simpleFilter),
    value: simpleFilter.value,
    not: getNotFromSimpleFilter(simpleFilter),
  }),
};
